<template>
  <div>
    <MultipleSectionSelector
      :initial-cat="initialCat"
      :initial-sub="initialSub"
      :initial-secs="initialSecs"
      @input="setSection"
    />

    <a-divider />
    <div>
      <a-form
        layout="horizontal"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 10 }"
      >
        <a-form-item :label="$t('product.title') + ' (RU)'">
          <a-input v-model="suggestion.title.ru" />
        </a-form-item>
        <a-form-item :label="$t('product.title') + ' (O\'z)'">
          <a-input v-model="suggestion.title.uz" />
        </a-form-item>
        <a-form-item :label="$t('product.ikpu')">
          <a-select
            v-model="ikpu"
            placeholder="Выберите элемент"
            @change="handleSelectChange"
            @search="handleSearch"
            :allowClear="true"
            show-search
          >
          <a-select-option v-for="item in items" :key="item.mxikCode" :value="item.mxikCode">{{ item.name }}</a-select-option>
          </a-select>
          <!-- <a-input
            v-model="ikpu"
            @blur="validateIkpu"
            @change="onIkpuChange"
          /> -->
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import soliqService from '@/services/api/admin/library/soliq-service'
import MultipleSectionSelector from '@/components/product/add/MultipleSectionSelector'
import { mapGetters } from 'vuex'

export default {
  name: 'ProductPicker',
  components: {
    MultipleSectionSelector,
  },
  props: {
    initialSecs: {
      type: Array,
      default () {
        return []
      },
    },
    initialCat: {
      type: Number,
      default() {
        return undefined
      },
    },
    initialSub: {
      type: Number,
      default() {
        return undefined
      },
    },
  },
  data () {
    return {
      productForm: {
        priority: null,
      },
      apiSoliq: soliqService,
      // picked data
      suggestion: {
        title: {
          ru: '',
          uz: '',
        },
        code: '',
      },
      items: [],
      ikpu: '',
      // ikpuInvalid: true,
      sectionIds: [],
      category: undefined,
      subCategory: undefined,
    }
  },
  computed: {
    ...mapGetters({
      userRole: 'user/role',
    }),
  },
  methods: {
    validateSelection () {
      if (this.sectionIds == null || this.sectionIds.length === 0 || this.suggestion.title.ru.length === 0 || this.suggestion.title.uz.length === 0) {
        this.$notification.error({ message: this.$t('common.error'), description: this.$t('product_add.messages.fill_step1') })
        return
      } else if (this.ikpuInvalid) {
        this.$notification.error({ message: this.$t('common.error'), description: this.$t('product_add.messages.invalid_ikpu') })
        return
      }

      this.suggestion.section_id = this.sectionIds

      const payload = {
        section_id: this.sectionIds,
        suggestion: this.suggestion,
        ikpu: this.ikpu,
        category: this.category,
        sub_category: this.subCategory,
      }
      this.$emit('input', payload)
    },
    handleSelectChange () {
      console.log('Selected option:', this.ikpu)
    },
    handleSearch(input) {
      this.items = []
      this.apiSoliq.getTest(input).then((response) => {
        console.log('response', response)
        if (response && response.data && response.data.data) {
          this.items = response.data.data
          console.log('items', this.items)
        } else {
          this.items = []
        }
        // this.$notification.success({
        //   message: this.$t('common.success'),
        //   description: this.$t('product_add.messages.show_on_list_changed'),
        // })
      })
    },
    onIkpuChange (e) {
      console.log(e)
      const { value } = e.target
      const numberRegex = /^\d+$/
      if (numberRegex.test(value) && !isNaN(value)) {
        this.ikpu = value
      } else {
        this.ikpu = this.ikpu.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1')
      }
    },
    validateIkpu(e) {
      const { value } = e.target
      if (value.length !== 17) {
        this.$notification.error({ message: this.$t('common.error'), description: this.$t('product_add.messages.ikpu_required') })
        this.ikpuInvalid = true
        e.target.classList.add('errorInput')
        e.target.classList.remove('successInput')
      } else {
        this.ikpuInvalid = false
        e.target.classList.remove('errorInput')
        e.target.classList.add('successInput')
      }
    },
    setSection (sectionIds, category, subCategory) {
      this.sectionIds = sectionIds
      this.category = category
      this.subCategory = subCategory
    },
  },
}
</script>

<style scoped>
  .errorInput {
    border: 1px solid red;
  }
  .successInput {
    border: 1px solid rgb(33, 207, 17);
  }
</style>
